import { render, staticRenderFns } from "./welcome.vue?vue&type=template&id=145b2b60&scoped=true&"
import script from "./welcome.vue?vue&type=script&lang=js&"
export * from "./welcome.vue?vue&type=script&lang=js&"
import style0 from "./welcome.vue?vue&type=style&index=0&id=145b2b60&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "145b2b60",
  null
  
)

export default component.exports